export default __webpack_public_path__ + "static/media/logoNVIDIA.83b10a49.png";